import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Project } from '@/types/project'

export function createProject(body: Project): Promise<AxiosResponse<unknown>> {
  return instance.post(`/iam/project`, body)
}
